const GLOBAL_GROUP = "onland_global";
const GLOBAL_PAGE_PATH = "/xr-creator/projects/:projectId";
const GLOBAL_PAGE_TITLE = "XR Creator Project";

function globalPageLocation(pagePath = GLOBAL_PAGE_PATH) {
  return `${window.location.origin}${pagePath}`;
}

export function initialize(gaTrackingId, globalMeasurementId) {
  const loaderMeasurementId = gaTrackingId || globalMeasurementId;
  if (!loaderMeasurementId) {
    return;
  }

  if (!window.gtag) {
    const gtmScript = document.createElement("script");
    gtmScript.type = "text/javascript";
    gtmScript.async = true;
    gtmScript.src = "https://www.googletagmanager.com/gtag/js?id=" + loaderMeasurementId;

    document.head.appendChild(gtmScript);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
  }

  if (gaTrackingId) {
    window.gtag("config", gaTrackingId, { send_page_view: false });
  }
  if (globalMeasurementId) {
    window.gtag("config", globalMeasurementId, {
      send_page_view: false,
      groups: GLOBAL_GROUP,
      page_location: globalPageLocation(),
      page_title: GLOBAL_PAGE_TITLE,
      page_referrer: ""
    });
  }
}

function sanitizePagePath(pagePath) {
  const rawPagePath = String(pagePath || "/")
    .split("?")[0]
    .split("#")[0];
  const normalizedPagePath = rawPagePath.startsWith("/") ? rawPagePath : `/${rawPagePath}`;

  return normalizedPagePath.replace(/\/+$/, "") || "/";
}

export function sendGlobalJourneyPageView(globalMeasurementId, pageView) {
  if (!globalMeasurementId || !pageView || !window.gtag) {
    return;
  }

  const pagePath = sanitizePagePath(pageView.pagePath);

  window.gtag("event", "page_view", {
    send_to: GLOBAL_GROUP,
    page_title: pageView.pageTitle,
    page_path: pagePath,
    page_location: globalPageLocation(pagePath),
    page_referrer: "",
    page_type: pageView.pageType,
    app_area: pageView.appArea
  });
}
